const map = {
	"./comp1.png": 340,
	"./comp2.png": 95,
	"./comp3.png": 870,
	"./comp4.png": 585,
	"./comp5.png": 456,
	"./comp6.png": 211,
	"./comp7.png": 2,
	"./comp8.png": 597,
	"./comp9.png": 916
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;